module.exports = __webpack_public_path__ + "img/lookbook.d6c233cb.jpg";